import bind from 'bind-decorator';

import { UniqueFilenameGenerator, getUniqueFilenameGenerator } from '@egr/xbox/utils/File';
import { prefixReturnValue, parseFilename } from '@egr/xbox/utils/String';
import { isUUID } from '@egr/xbox/utils/Helper';
import { assert } from '@egr/xbox/utils/Debug';

import { isNotNullOrEmpty } from '@egr/wcf/modules/utils/string';

interface ShareFilenameSettings {
    projectName: string;
    articleFilename?: string;
    allowSubFolders?: boolean;
}

export class ShareFilenameManager {
    protected generatorCache: Map<string, UniqueFilenameGenerator> = new Map();

    public constructor(protected shareSettings: ShareFilenameSettings) {
    }

    @bind
    public getFilename(extension: string, category: string = '', originalName?: string, suffix?: string): string {
        const generator: UniqueFilenameGenerator = this.getFilenameGenerator(category);

        if (isNotNullOrEmpty(originalName)) {
            const [name, parsedExtension] = parseFilename(originalName);
            if (isNotNullOrEmpty(name) && !isUUID(name)) {
                assert(extension === parsedExtension || parsedExtension === '', 'file extension should not be changed');
                return generator(name + (suffix ?? ''), extension);
            }
        }

        return generator(
            (this.shareSettings.articleFilename ?? this.shareSettings.projectName) + (suffix ?? ''),
            extension
        );
    }

    protected getFilenameGenerator(path: string): UniqueFilenameGenerator {
        if (this.shareSettings.allowSubFolders !== true) {
            path = '';
        }

        const generator: UniqueFilenameGenerator | undefined = this.generatorCache.get(path);
        if (generator != null) {
            return generator;
        }

        const newGenerator: UniqueFilenameGenerator = prefixReturnValue(
            this.shareSettings.allowSubFolders === true ? `${path}/` : '',
            getUniqueFilenameGenerator()
        );
        this.generatorCache.set(path, newGenerator);

        return newGenerator;
    }
}